{
  "aviosLinkingAndExchange": {
    "loadingText": "Loading linked accounts",
    "moreAccounts": "View all linked accounts on avios.com"
  }
}
